<template>
    <div></div>
</template>
  
<script>
export default {
  name: 'TutorialSection',
  data() {
    return {
    }
  },
  mounted: function () {
    window.addEventListener('message', this.setAuth)
  },
  unmounted: function () {
    window.removeEventListener('message', this.setAuth)
  },
  methods: {
    setAuth(event) {
      if (event && event.data && event.data.auth) {
        this.$store.dispatch('storeAccessToken', event.data.auth)
      }
    }
  }
}
</script>
  